import React, { useState, useRef, useEffect } from "react";
import {
  Card, Table, Form, Dropdown, Button, Row, Col, Modal
} from "react-bootstrap";
import { FiEdit, FiTrash, FiCalendar } from "react-icons/fi";
import EditEmployeeModal from "../../modals/hrm/employee/EditEmployeeModal";
import { Link } from "react-router-dom";
import DeleteEmployeeModal from "../../modals/hrm/employee/DeleteEmployeeModal";
import {  FiChevronDown } from "react-icons/fi";

export default function PlanList() {

  const [search, setSearch] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const data = [
    {
      id: "Emp-001",
      name: "Anthony Lewis",
      Email:"vamsi@",
      role: "Finance",
      phone: "(123) 4567 890",
      status: "Active",
      date: "12 Sep 2024",
      img: "/assets/img/agents/agent-01.jpg"
    },
    {
      id: "Emp-002",
      name: "Brian Villalobos",
         Email:"prakash@",
      role: "Developer",
      phone: "(179) 7382 829",
      status: "Active",
      date: "24 Oct 2024",
         img: "/assets/img/agents/agent-08.jpg"

    },
      {
      id: "Emp-003",
      name: "monish",
      Email:"vamsi@",
      role: "Finance",
      phone: "(123) 4567 890",
      status: "Active",
      date: "12 Sep 2024",
      img: "/assets/img/agents/agent-03.jpg"
    },
      {
      id: "Emp-004",
      name: "virat kholi",
      Email:"viratkholi@123",
      role: "account",
      phone: "(123) 4567 890",
      status: "Active",
      date: "12 Sep 2024",
      img: "/assets/img/agents/agent-04.jpg"
    },
      {
      id: "Emp-005",
      name: "jackob",
      Email:"bethly@",
      role: "devloper",
      phone: "(123) 4567 890",
      status: "non-active",
      date: "13 aug 2026",
      img: "/assets/img/agents/agent-05.jpg"
    },
      {
      id: "Emp-001",
      name: "Cummins",
      Email:"cummines@",
      role: "Digital Marketing",
      phone: "(123) 4567 890",
      status: "Non-active",
      date: "1 nov2024",
      img: "/assets/img/agents/agent-06.jpg"
    },
  ];

  const filtered = data.filter(d =>
    d.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = () => {
   data()
    console.log('Items deleted');
    setShowDelete(false);
  };

    const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };

  // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };

  return (
    <>
      <Card 
style={{ borderRadius: "6px",    border: "1px solid #e3e3e3",
 background: "rgb(255 255 255)",
 }} className="mt-4">
        {/* HEADER */}
<div   style={{ background: "rgb(255 255 255)",}} >
          <Card.Header   style={{ background: "rgb(255 255 255)",}}  className="d-flex justify-content-between flex-wrap gap-3">

          <h5>Plan List</h5>

          <div className="d-flex flex-wrap gap-2">

 <div ref={containerRef} style={{ position: "relative", width: 230 }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* MOBILE */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>


            {/* DESIGNATION */}
            <Dropdown>
              <Dropdown.Toggle className=" border">
                Designation
              </Dropdown.Toggle>
              <Dropdown.Menu className="p-2 bg-white text-dark">
                {["Finance","Developer","Executive"].map((item,i)=>(
                  <Dropdown.Item key={i} className="">
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* STATUS */}
            <Dropdown>
              <Dropdown.Toggle className=" border">
                Select Status
              </Dropdown.Toggle>
              <Dropdown.Menu className="p-2 bg-white text-dark">
                {["Active","Inactive"].map((item,i)=>(
                  <Dropdown.Item key={i} className="">
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* SORT */}
            <Dropdown>
              <Dropdown.Toggle className=" border">
                Sort By : Last 7 Days
              </Dropdown.Toggle>
              <Dropdown.Menu className="p-2 bg-white text-dark">
                {["Recently Added","Ascending","Descending","Last Month","Last 7 Days"].map((item,i)=>(
                  <Dropdown.Item key={i} className={item==="Last 7 Days"?"":""}>
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

          </div>
        </Card.Header>
<Row className="align-items-center justify-content-between p-3 ">

  {/* LEFT SIDE */}
  <Col md="auto" className="d-flex align-items-center gap-2">
    <span className="text-muted">Row Per Page</span>

    <Form.Select className="entries-select">
      <option>10</option>
      <option>25</option>
      <option>50</option>
    </Form.Select>

    <span className="text-muted">Entries</span>
  </Col>

  {/* RIGHT SIDE */}
  <Col md="auto" className="text-md-end mt-2 mt-md-0">
    <Form.Control
      placeholder="Search"
      className="search-input"
      onChange={(e) => setSearch(e.target.value)}
    />
  </Col>

</Row>
</div>

        {/* TABLE */}
        <Table responsive className="align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th><Form.Check /></th>
              <th>Emp ID</th>
              <th>Name</th>
              <th>Emails</th>

              <th>Phone</th>
              <th>Designation</th>
              <th>Joining Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, i)=>(
              <tr key={i}>
                <td><Form.Check /></td>

                <td>{item.id}</td>

                <td>
                  <div className="d-flex align-items-center">
<Link  to="/employees-details" >
                    <img src={item.img} className="avatar-sm me-2" />

</Link>

                    <div>
                    
                      <Link  className="text-decoration-none text-dark" to="/employees-details" >
  <div>{item.name}</div>
</Link>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </td>
                <td>{item.Email}</td>


                <td>{item.phone}</td>

                <td>
                  <Form.Select className="small-select">
                    <option>Finance</option>
                    <option>Developer</option>
                    <option>Executive</option>
                  </Form.Select>
                </td>

                <td>{item.date}</td>

                <td>
                  <span className={`badge ${item.status==="Active"?"badge-green":"badge-red"}`}>
                    ● {item.status}
                  </span>
                </td>

                <td>
                  <FiEdit className="me-2 cursor" onClick={()=>setShowEdit(true)} />
                  <FiTrash className="cursor" onClick={()=>setShowDelete(true)} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <style>
          {
               `
               /* ORANGE */
.btn-orange {
  background: #f26522;
  border: none;
}

/* DROPDOWN ACTIVE */
.active-orange {
  background: #f26522 !important;
  color: #fff !important;
}

/* AVATAR */
.avatar-sm {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

/* BADGES */
.badge-green {
  background: #22c55e;
  color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
}

.badge-red {
  background: #ef4444;
  color: #fff;
}

/* SELECT */
.small-select {
  font-size: 13px;
}

/* UPLOAD */
.upload-box {
  text-align: center;
}
.profile-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
  /* ✅ FORCE WHITE BUTTON STYLE */
.btn-white {
  background-color: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #111827 !important;
  border-radius: 6px;
  padding: 6px 12px;
}

/* REMOVE ORANGE FROM TOGGLE */
.dropdown-toggle {
  background-color: #ffffff !important;
  color: #111827 !important;
  border: 1px solid #e5e7eb !important;
}

/* HOVER */
.dropdown-toggle:hover {
  background-color: #f9fafb !important;
}

/* ACTIVE CLICK FIX */
.dropdown-toggle:focus,
.dropdown-toggle:active {
  background-color: #ffffff !important;
  color: #111827 !important;
  box-shadow: none !important;
}

/* ✅ KEEP ORANGE ONLY INSIDE DROPDOWN ITEMS */
.active-orange {
//   background-color: #f26522 !important;
  color: #fff !important;
}
/* CURSOR */
.cursor {
  cursor: pointer;
}
/* HEADER CONTAINER */
.table-header {
  background: #f9fafb;
  border-bottom: 1px solid #eee;
}

/* SELECT DROPDOWN */
.entries-select {
  width: 70px;
  height: 32px;
  font-size: 13px;
  border-radius: 6px;
}

/* SEARCH BOX */
.search-input {
  width: 220px;
  height: 34px;
  font-size: 13px;
  border-radius: 6px;
}
  

/* MOBILE FIX */
@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }
}
.dropdown-toggle::after {
  display: none !important; }
/* MOBILE */
@media(max-width:768px){
  .w-25{
    width:100% !important;
  }
}`
          }
        </style>
      </Card>

      {/* EDIT MODAL */}
<EditEmployeeModal
  show={showEdit}
  handleClose={() => setShowEdit(false)}
/>
      {/* DELETE MODAL */}

      <DeleteEmployeeModal
        showDelete={showDelete}
        setShowDelete={setShowDelete}
        onConfirmDelete={handleDelete}
       onHide={()=>setShowDelete(false)}
      />
    </>
  );
}